// Licenses page (#/licenses): register a license key into the user's account and bind/move/unbind it to a
// slot via a slot picker. Admin "view as" shows the target user's licenses (GET auto-scopes); registering a
// new key is disabled while viewing as someone else (registration always targets the caller's account).
'use strict';
(function () {
  const App = window.App;
  const t = App.t, esc = App.esc, api = App.api;

  App.i18n.add({
    ko: {
      licp_desc: '관리자가 발급한 라이선스 키를 등록하고, 내 슬롯에 연결하세요.',
      licp_register_title: '라이선스 키 등록', licp_register_label: '라이선스 키',
      licp_register_btn: '등록', licp_register_hint: '관리자가 발급한 키를 입력하세요. 여러 개는 줄바꿈·공백·쉼표로 구분해 한 번에 등록할 수 있습니다.',
      licp_registered: '라이선스를 등록했습니다.',
      licp_viewas_disabled: '다른 사용자 화면에서는 키를 등록할 수 없습니다. 내 화면으로 돌아가 등록하세요.',
      licp_e_bad_key: '키 형식이 올바르지 않습니다. LBOT-XXXX-XXXX-XXXX 형식으로 입력하세요.',
      licp_e_not_found: '존재하지 않는 키입니다. 관리자에게 확인하세요.',
      licp_e_already_registered: '이미 다른 사용자가 등록한 키입니다.',
      licp_e_already_mine: '이미 내 계정에 등록된 키입니다.',
      licp_e_revoked: '회수된 키입니다. 사용할 수 없습니다.',
      licp_f_all: '전체', licp_f_usable: '사용 가능', licp_f_expired: '만료·회수',
      licp_empty_filter: '조건에 맞는 라이선스가 없습니다.',
      licp_empty_title: '등록된 라이선스가 없습니다',
      licp_empty_desc: '라이선스 키는 관리자가 발급합니다. 발급받은 키를 위 등록 상자에 입력하세요.',
      licp_exp_unregistered: '아직 어떤 계정에도 등록되지 않은 키입니다.',
      licp_exp_unused: '아직 슬롯에 연결되지 않았습니다. 슬롯에 연결하면 사용 준비가 됩니다.',
      licp_exp_waiting: '슬롯에 연결되었습니다. 게임을 처음 실행하면 기간이 시작됩니다.',
      licp_exp_active: '사용 중입니다.', licp_exp_expired: '기간이 만료되었습니다.',
      licp_exp_revoked: '관리자가 회수한 라이선스입니다.',
      licp_duration: '전체 기간', licp_remaining: '남은 기간', licp_activated: '시작일', licp_expiry: '만료일',
      licp_bound: '연결된 슬롯', licp_unbound_slot: '연결된 슬롯 없음',
      licp_connect: '슬롯에 연결', licp_move: '다른 슬롯으로 이동', licp_unbind: '연결 해제',
      licp_unbind_confirm: '이 라이선스의 슬롯 연결을 해제할까요? 라이선스는 미사용 상태로 돌아갑니다. (남은 기간은 유지됩니다)',
      licp_unbound: '연결을 해제했습니다.',
      licp_pick_title: '슬롯에 연결', licp_pick_desc: '이 라이선스를 연결할 슬롯을 선택하세요.',
      licp_select: '연결', licp_replace: '교체', licp_slot_current: '이 라이선스가 연결된 슬롯',
      licp_slot_current_badge: '연결됨', licp_slot_has_lic: '이미 다른 라이선스가 연결됨 · 선택하면 교체됩니다',
      licp_replace_confirm: '‘{0}’ 슬롯에는 이미 다른 라이선스가 연결되어 있습니다. 교체할까요?',
      licp_replace_detail: '기존 라이선스는 미사용 상태로 돌아갑니다.',
      licp_no_slots: '연결할 슬롯이 없습니다. 먼저 머신에 게임 계정을 추가하세요.',
      licp_go_machines: '머신 페이지로 이동',
      licp_bound_ok: '슬롯에 연결했습니다.', licp_moved: '다른 슬롯에서 이동해 연결했습니다.',
      licp_e_not_owned: '내 라이선스가 아닙니다.',
      licp_e_revoked_bind: '회수된 라이선스는 연결할 수 없습니다.',
      licp_e_expired_bind: '만료된 라이선스는 연결할 수 없습니다.',
      licp_e_not_found_bind: '대상을 찾을 수 없습니다.',
      licp_reg_results: '등록 결과', licp_reg_ok: '등록됨',
      licp_reg_multi_ok: '{0}/{1}개 라이선스를 등록했습니다.', licp_reg_multi_none: '등록된 라이선스가 없습니다.',
      licp_sel_aria: '선택', licp_sel_all: '전체 선택', licp_sel_count: '{0}개 선택됨', licp_sel_clear: '선택 해제',
      licp_bulk_unbind_confirm: '선택한 라이선스 {0}개의 슬롯 연결을 해제할까요? (남은 기간은 유지됩니다)',
      licp_bulk_done: '{0}개 연결을 해제했습니다.', licp_bulk_partial: '{0}개 해제, {1}개 실패했습니다.'
    },
    'zh-CN': {
      licp_desc: '登记管理员发放的授权密钥，并连接到我的槽位。',
      licp_register_title: '登记授权密钥', licp_register_label: '授权密钥',
      licp_register_btn: '登记', licp_register_hint: '输入管理员发放的密钥。多个密钥可用换行、空格或逗号分隔，一次性登记。',
      licp_registered: '已登记授权。',
      licp_viewas_disabled: '在其他用户界面下无法登记密钥。请返回我的界面后登记。',
      licp_e_bad_key: '密钥格式不正确。请按 LBOT-XXXX-XXXX-XXXX 格式输入。',
      licp_e_not_found: '密钥不存在，请向管理员确认。',
      licp_e_already_registered: '该密钥已被其他用户登记。',
      licp_e_already_mine: '该密钥已登记在我的账户。',
      licp_e_revoked: '该密钥已被收回，无法使用。',
      licp_f_all: '全部', licp_f_usable: '可用', licp_f_expired: '过期·收回',
      licp_empty_filter: '没有符合条件的授权。',
      licp_empty_title: '尚未登记授权',
      licp_empty_desc: '授权密钥由管理员发放。请将发放的密钥输入上方登记框。',
      licp_exp_unregistered: '尚未登记到任何账户的密钥。',
      licp_exp_unused: '尚未连接到槽位。连接到槽位后即可使用。',
      licp_exp_waiting: '已连接到槽位。首次运行游戏时开始计时。',
      licp_exp_active: '使用中。', licp_exp_expired: '已过期。',
      licp_exp_revoked: '管理员已收回的授权。',
      licp_duration: '总时长', licp_remaining: '剩余时长', licp_activated: '开始日', licp_expiry: '到期日',
      licp_bound: '连接的槽位', licp_unbound_slot: '未连接槽位',
      licp_connect: '连接到槽位', licp_move: '移动到其他槽位', licp_unbind: '解除连接',
      licp_unbind_confirm: '要解除此授权的槽位连接吗？授权会回到未使用状态。（剩余时长保留）',
      licp_unbound: '已解除连接。',
      licp_pick_title: '连接到槽位', licp_pick_desc: '选择要连接此授权的槽位。',
      licp_select: '连接', licp_replace: '替换', licp_slot_current: '此授权连接的槽位',
      licp_slot_current_badge: '已连接', licp_slot_has_lic: '已连接其他授权 · 选择后将替换',
      licp_replace_confirm: '槽位“{0}”已连接其他授权。要替换吗？',
      licp_replace_detail: '原授权会回到未使用状态。',
      licp_no_slots: '没有可连接的槽位。请先在机器上添加游戏账号。',
      licp_go_machines: '前往机器页面',
      licp_bound_ok: '已连接到槽位。', licp_moved: '已从其他槽位移动并连接。',
      licp_e_not_owned: '不是我的授权。',
      licp_e_revoked_bind: '已收回的授权无法连接。',
      licp_e_expired_bind: '已过期的授权无法连接。',
      licp_e_not_found_bind: '找不到对象。',
      licp_reg_results: '登记结果', licp_reg_ok: '已登记',
      licp_reg_multi_ok: '已登记 {0}/{1} 个授权。', licp_reg_multi_none: '没有登记任何授权。',
      licp_sel_aria: '选择', licp_sel_all: '全选', licp_sel_count: '已选 {0} 个', licp_sel_clear: '取消选择',
      licp_bulk_unbind_confirm: '要解除所选 {0} 个授权的槽位连接吗？（剩余时长保留）',
      licp_bulk_done: '已解除 {0} 个连接。', licp_bulk_partial: '解除 {0} 个，失败 {1} 个。'
    }
  });

  const USABLE = ['unused', 'waiting', 'active'];
  const apiError = (r, overrides) => {
    const code = r && r.data && r.data.err;
    return code && overrides && overrides[code] ? t(overrides[code]) : App.errorText(r && r.data);
  };

  App.page('licenses', {
    title: () => t('nav_licenses'),
    nav: { group: 'main', order: 30, icon: '🔑' },
    render(root) {
      const wrap = document.createElement('div');
      wrap.className = 'page narrow';
      root.appendChild(wrap);
      const state = { licenses: [], filter: 'all', loaded: false, regResults: null };
      const viewAs = !!App.viewAs;
      const current = () => document.body.contains(wrap);
      let sel = null;

      skeleton();
      reload();

      const offRoster = App.ws.on('roster', reload);
      wrap.addEventListener('click', onClick);

      return () => { offRoster(); if (sel) sel.destroy(); };

      async function reload() {
        try {
          const r = await api('/api/licenses');
          if (!current()) return;
          state.licenses = (r.data && r.data.licenses) || [];
          state.loaded = true;
          paint();
        } catch (error) { console.error(error); if (current()) errorState(); }
      }

      function head() {
        return `<div class="page-head"><div class="titles"><h1>${esc(t('nav_licenses'))}</h1><p class="desc">${esc(t('licp_desc'))}</p></div></div>`;
      }
      function skeleton() {
        wrap.innerHTML = head() + `<div class="skeleton" style="height:120px"></div><div class="skeleton" style="height:120px"></div>`;
      }
      function errorState() {
        wrap.innerHTML = head() + `<div class="empty-state"><div class="empty-icon">⚠️</div><p>${esc(t('e_fail'))}</p><button class="btn secondary" data-act="refresh">${esc(t('retry'))}</button></div>`;
      }

      function registerCard() {
        if (viewAs) return `<div class="card"><div class="card-body"><div class="banner info"><span aria-hidden="true">ℹ️</span><span>${esc(t('licp_viewas_disabled'))}</span></div></div></div>`;
        return `<div class="card"><div class="card-head"><h3>${esc(t('licp_register_title'))}</h3></div>
          <div class="card-body"><div class="field" id="regField">
            <label for="licKey">${esc(t('licp_register_label'))}</label>
            <div class="input-action">
              <input id="licKey" class="mono" autocomplete="off" spellcheck="false" maxlength="4000" placeholder="LBOT-XXXX-XXXX-XXXX" aria-describedby="licErr">
              <button class="btn primary" data-act="register">${esc(t('licp_register_btn'))}</button>
            </div>
            <div class="error" id="licErr" role="alert"></div>
            <div class="hint">${esc(t('licp_register_hint'))}</div>
          </div></div></div>`;
      }
      function controlsBar() {
        const opts = [['all', 'licp_f_all'], ['usable', 'licp_f_usable'], ['expired', 'licp_f_expired']];
        return `<div class="toolbar row between"><div class="seg">${opts.map(([v, k]) =>
          `<button class="${state.filter === v ? 'on' : ''}" data-act="filter" data-filter="${v}">${esc(t(k))}</button>`).join('')}</div>` +
          `<label class="check"><input class="sel-all" type="checkbox"> ${esc(t('licp_sel_all'))}</label></div>`;
      }
      function emptyAllHtml() {
        return `<div class="empty-state"><div class="empty-icon">🔑</div><p>${esc(t('licp_empty_title'))}</p><p class="small muted">${esc(t('licp_empty_desc'))}</p></div>`;
      }
      function resultsHtml() {
        const inner = (!state.regResults || !state.regResults.length) ? '' :
          `<div class="card"><div class="card-body stack tight"><div class="small muted">${esc(t('licp_reg_results'))}</div>` +
          state.regResults.map((r) => `<div class="row small"><span class="badge ${r.ok ? 'ok' : 'bad'}">${r.ok ? '✓' : '✕'}</span><code class="mono">${esc(r.key)}</code><span class="${r.ok ? 'muted' : 'bad'}">${esc(r.msg)}</span></div>`).join('') +
          `</div></div>`;
        return `<div id="regResults">${inner}</div>`;
      }
      function byId(id) { return state.licenses.find((l) => l.id === id); }
      function fmtKey(tok) { const a = String(tok).toUpperCase().replace(/[^A-Z0-9]/g, ''); return a.length === 16 ? a.replace(/(.{4})(?=.)/g, '$1-') : String(tok).trim().toUpperCase(); }
      function renderBulk(ids) {
        const bar = wrap.querySelector('#bulkBar'); if (!bar) return;
        if (!ids || !ids.length) { bar.innerHTML = ''; return; }
        const bound = ids.map((id) => byId(Number(id))).filter((l) => l && l.slot).length;
        bar.innerHTML = `<div class="bulk-bar"><span class="count">${esc(t('licp_sel_count', ids.length))}</span>` +
          `<button class="btn sm danger" data-act="bulk-unbind"${bound ? '' : ' disabled'}>${esc(t('licp_unbind'))}${bound ? ` (${bound})` : ''}</button>` +
          `<button class="btn sm ghost" data-act="bulk-clear">${esc(t('licp_sel_clear'))}</button></div>`;
      }
      async function bulkUnbind() {
        if (!sel) return;
        const bound = sel.ids().map((id) => byId(Number(id))).filter((l) => l && l.slot);
        if (!bound.length) return;
        if (!await App.confirm({ title: t('licp_unbind'), message: t('licp_bulk_unbind_confirm', bound.length), confirm: t('licp_unbind'), danger: true })) return;
        let done = 0, failed = 0;
        for (const l of bound) { const r = await api('/api/slots/' + l.slot.id + '/license', { method: 'PUT', body: { license_id: null } }); if (r.ok) done++; else failed++; }
        App.toast(failed ? t('licp_bulk_partial', done, failed) : t('licp_bulk_done', done), failed ? 'error' : 'ok');
        if (sel) sel.clear();
        reload();
      }
      function filtered() {
        if (state.filter === 'usable') return state.licenses.filter((l) => USABLE.includes(l.status));
        if (state.filter === 'expired') return state.licenses.filter((l) => ['expired', 'revoked'].includes(l.status));
        return state.licenses;
      }
      function listHtml() {
        const items = filtered();
        if (!items.length) return `<div class="panel muted small">${esc(t('licp_empty_filter'))}</div>`;
        return `<div class="stack">${items.map(card).join('')}</div>`;
      }
      function kvItem(k, v) { return `<div><div class="k">${esc(k)}</div><div class="v">${esc(v)}</div></div>`; }
      function card(l) {
        const kv = [kvItem(t('licp_duration'), l.duration_days != null ? t('days_n', l.duration_days) : '—')];
        if (l.status === 'active' && l.remaining_days != null) kv.push(kvItem(t('licp_remaining'), t('days_n', l.remaining_days)));
        if (l.activated_at) kv.push(kvItem(t('licp_activated'), App.fmt.date(l.activated_at)));
        if (l.expires_at) kv.push(kvItem(t('licp_expiry'), App.fmt.date(l.expires_at)));
        const slot = l.slot
          ? esc(l.slot.machine_label) + ' · ' + esc(l.slot.game_account) + (l.slot.nickname ? ' · ' + esc(l.slot.nickname) : '')
          : `<span class="faint">${esc(t('licp_unbound_slot'))}</span>`;
        const canBind = USABLE.includes(l.status);
        const actions = [];
        if (l.slot) {
          if (canBind) actions.push(`<button class="btn sm secondary" data-act="move" data-lic="${l.id}">${esc(t('licp_move'))}</button>`);
          actions.push(`<button class="btn sm danger" data-act="unbind" data-lic="${l.id}" data-slot="${l.slot.id}">${esc(t('licp_unbind'))}</button>`);
        } else if (canBind) {
          actions.push(`<button class="btn sm primary" data-act="connect" data-lic="${l.id}">${esc(t('licp_connect'))}</button>`);
        }
        return `<div class="card" data-sel="${l.id}">
          <div class="card-head"><input class="sel-row" type="checkbox" aria-label="${esc(t('licp_sel_aria'))}"><code class="mono grow">${esc(l.key_hint)}</code>${App.licenseBadge(l)}</div>
          <div class="card-body stack">
            <p class="muted small">${esc(t('licp_exp_' + l.status))}</p>
            <div class="kv">${kv.join('')}</div>
            <div class="row small"><span class="muted">${esc(t('licp_bound'))}:</span> <span>${slot}</span></div>
          </div>
          ${actions.length ? `<div class="card-foot">${actions.join('')}</div>` : ''}
        </div>`;
      }

      function paint() {
        const hasList = state.licenses.length > 0;
        const body = hasList
          ? `<div id="licSel">${controlsBar()}<div id="bulkBar"></div>${listHtml()}</div>`
          : emptyAllHtml();
        wrap.innerHTML = head() + registerCard() + resultsHtml() + body;
        wireRegister();
        if (sel) { sel.destroy(); sel = null; }
        if (hasList) { sel = App.selectable(wrap.querySelector('#licSel'), { onChange: renderBulk }); renderBulk([]); }
      }

      function wireRegister() {
        const input = wrap.querySelector('#licKey');
        if (!input) return;
        input.addEventListener('input', () => {
          const v = input.value;
          if (/[\s,;]/.test(v) || v.replace(/[^A-Za-z0-9]/g, '').length > 16) return; // multi-key: leave as typed
          const caret = input.selectionStart;
          const alnumBefore = v.slice(0, caret).replace(/[^A-Za-z0-9]/g, '').length;
          const raw = v.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 16);
          const formatted = raw.replace(/(.{4})(?=.)/g, '$1-');
          if (formatted === v) return;
          input.value = formatted;
          let pos = 0, seen = 0;
          while (pos < formatted.length && seen < alnumBefore) { if (/[A-Z0-9]/.test(formatted[pos])) seen++; pos++; }
          if (formatted[pos] === '-') pos++;
          input.setSelectionRange(pos, pos);
        });
        input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); register(); } });
      }

      async function register() {
        const input = wrap.querySelector('#licKey'), errEl = wrap.querySelector('#licErr'), field = wrap.querySelector('#regField');
        const btn = wrap.querySelector('[data-act="register"]');
        state.regResults = null;
        const rc = wrap.querySelector('#regResults'); if (rc) rc.innerHTML = '';
        errEl.textContent = ''; field.classList.remove('invalid');
        const tokens = input.value.trim().split(/[\s,;]+/).filter(Boolean);
        if (!tokens.length) { field.classList.add('invalid'); errEl.textContent = t('licp_e_bad_key'); input.focus(); return; }
        const codes = { bad_key: 'licp_e_bad_key', not_found: 'licp_e_not_found', already_registered: 'licp_e_already_registered', already_mine: 'licp_e_already_mine', revoked: 'licp_e_revoked' };
        if (tokens.length === 1) {
          btn.disabled = true;
          const r = await api('/api/licenses/register', { method: 'POST', body: { key: tokens[0] } });
          btn.disabled = false;
          if (!r.ok) { field.classList.add('invalid'); errEl.textContent = apiError(r, codes); input.focus(); return; }
          App.toast(t('licp_registered')); input.value = ''; reload(); return;
        }
        btn.disabled = true;
        const seen = new Set(), results = [];
        for (const tok of tokens) {
          const norm = tok.toUpperCase().replace(/[^A-Z0-9]/g, '');
          if (seen.has(norm)) continue;
          seen.add(norm);
          const r = await api('/api/licenses/register', { method: 'POST', body: { key: tok } });
          results.push({ key: fmtKey(tok), ok: r.ok, msg: r.ok ? t('licp_reg_ok') : apiError(r, codes) });
        }
        btn.disabled = false;
        state.regResults = results;
        input.value = '';
        const okN = results.filter((r) => r.ok).length;
        App.toast(okN ? t('licp_reg_multi_ok', okN, results.length) : t('licp_reg_multi_none'), okN ? 'ok' : 'error');
        reload();
      }

      function onClick(e) {
        const btn = e.target.closest('[data-act]');
        if (!btn) return;
        switch (btn.dataset.act) {
          case 'refresh': skeleton(); reload(); break;
          case 'register': register(); break;
          case 'filter': state.filter = btn.dataset.filter; paint(); break;
          case 'connect': case 'move': { const l = state.licenses.find((x) => x.id === Number(btn.dataset.lic)); if (l) openSlotPicker(l); break; }
          case 'unbind': unbind(Number(btn.dataset.slot)); break;
          case 'bulk-unbind': bulkUnbind(); break;
          case 'bulk-clear': if (sel) sel.clear(); break;
        }
      }

      async function unbind(slotId) {
        if (!await App.confirm({ title: t('licp_unbind'), message: t('licp_unbind_confirm'), confirm: t('licp_unbind'), danger: true })) return;
        const r = await api('/api/slots/' + slotId + '/license', { method: 'PUT', body: { license_id: null } });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('licp_unbound')); reload();
      }

      function openSlotPicker(lic) {
        const dlg = App.dialog({ title: t('licp_pick_title'), body: `<div class="skeleton" style="height:120px"></div>`, actions: [{ label: t('close'), kind: 'secondary' }] });
        loadSlots();
        async function loadSlots() {
          const r = await api('/api/machines');
          const machines = (r.data && r.data.machines) || [];
          const hasSlots = machines.some((m) => (m.slots || []).length);
          let html = `<p class="muted small">${esc(t('licp_pick_desc'))}</p>`;
          if (!hasSlots) {
            html += `<div class="empty-state"><div class="empty-icon">🖥</div><p>${esc(t('licp_no_slots'))}</p><a class="btn secondary" href="#/machines">${esc(t('licp_go_machines'))}</a></div>`;
          } else {
            for (const m of machines) {
              if (!(m.slots || []).length) continue;
              html += `<div class="section-head"><h4>${esc(m.label)}</h4></div>` + m.slots.map((s) => {
                const onThis = lic.slot && lic.slot.id === s.id;
                const otherLic = s.license && (!lic.slot || s.license.id !== lic.id);
                const note = onThis ? t('licp_slot_current')
                  : otherLic ? t('licp_slot_has_lic')
                  : (s.nickname ? s.nickname + (s.server_name ? '@' + s.server_name : '') : (s.server_name ? '@' + s.server_name : ''));
                const right = onThis ? `<span class="badge ok">${esc(t('licp_slot_current_badge'))}</span>`
                  : `<button class="btn sm primary" data-slot="${s.id}">${esc(otherLic ? t('licp_replace') : t('licp_select'))}</button>`;
                return `<div class="panel row between"><div class="grow"><div class="row"><span class="mono">${esc(s.game_account)}</span>${s.license ? App.licenseBadge(s.license) : ''}</div>
                  <div class="small muted">${esc(note)}</div></div>${right}</div>`;
              }).join('');
            }
          }
          dlg.body.innerHTML = html;
          dlg.body.querySelectorAll('[data-slot]').forEach((b) => {
            const sid = Number(b.dataset.slot);
            let slot = null;
            for (const m of machines) for (const s of (m.slots || [])) if (s.id === sid) slot = s;
            b.onclick = () => assign(slot);
          });
        }
        async function assign(slot) {
          if (!slot) return;
          const otherLic = slot.license && slot.license.id !== lic.id;
          if (otherLic && !await App.confirm({ title: t('licp_replace'), message: t('licp_replace_confirm', slot.game_account), detail: t('licp_replace_detail'), confirm: t('licp_replace'), danger: true })) return;
          const r = await api('/api/slots/' + slot.id + '/license', { method: 'PUT', body: { license_id: lic.id } });
          if (!r.ok) { App.toast(apiError(r, { license_not_owned: 'licp_e_not_owned', license_revoked: 'licp_e_revoked_bind', license_expired: 'licp_e_expired_bind', not_found: 'licp_e_not_found_bind' }), 'error'); return; }
          App.toast(r.data && r.data.moved_from_slot_id ? t('licp_moved') : t('licp_bound_ok'));
          dlg.close(true); reload();
        }
      }
    }
  });
})();
